function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M48 29.92a.94.94 0 00-.94-.93H42.4V24.3a.94.94 0 00-.94-.93h-3.11a.94.94 0 00-.94.93V29h-4.67a.94.94 0 00-.94.93v3.12c0 .52.42.93.94.93h4.67v4.68c0 .52.42.93.94.93h3.11a.94.94 0 00.94-.93v-4.68h4.67a.94.94 0 00.94-.93v-3.12zm-13.09 8.73v1.17c0 .9-.73 1.64-1.64 1.64H1.64A1.64 1.64 0 010 39.82v-1.64a7.64 7.64 0 017.64-7.64h1.94a15.28 15.28 0 0015.75 0h1.94c.69 0 1.37.1 2.03.28v2.22a3.43 3.43 0 003.43 3.43h1.99c.21.94.19 1.6.19 2.18zM6.54 17.45a10.91 10.91 0 1121.83 0 10.91 10.91 0 01-21.83 0z"
})));